// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__tr2Iq","requiredAsterisk":"Info_requiredAsterisk__2Iq_N"};